import { Category } from '../types';

export const categories: Category[] = [
  {
    id: 'finance',
    name: 'Business & Finance',
    icon: 'bar-chart',
    description: 'AI tools for financial analysis, investment, and business operations',
    subcategories: [
      {
        id: 'financial-analysis',
        name: 'Financial Analysis',
        description: 'Portfolio management and investment recommendation tools'
      },
      {
        id: 'business-intelligence',
        name: 'Business Intelligence',
        description: 'Data visualization and business insights platforms'
      },
      {
        id: 'document-processing',
        name: 'Document Processing',
        description: 'Automated document analysis, extraction, and management'
      }
    ]
  },
  {
    id: 'creative',
    name: 'Creative & Design',
    icon: 'palette',
    description: 'AI tools for design, art, music, and creative content generation',
    subcategories: [
      {
        id: 'image-generation',
        name: 'Image Generation',
        description: 'AI art and image creation tools'
      },
      {
        id: 'video-editing',
        name: 'Video Editing',
        description: 'AI-powered video creation and editing solutions'
      },
      {
        id: '3d-modeling',
        name: '3D Modeling',
        description: 'Generate and manipulate 3D models with AI assistance'
      }
    ]
  },
  {
    id: 'education',
    name: 'Education & Learning',
    icon: 'graduation-cap',
    description: 'AI solutions for learning, teaching, and educational administration',
    subcategories: [
      {
        id: 'study-tools',
        name: 'Study Tools',
        description: 'Personalized learning platforms and study assistants'
      },
      {
        id: 'course-creation',
        name: 'Course Creation',
        description: 'Tools for educators to create and manage learning content'
      },
      {
        id: 'language-learning',
        name: 'Language Learning',
        description: 'AI-powered language acquisition and translation tools'
      }
    ]
  },
  {
    id: 'healthcare',
    name: 'Healthcare & Wellness',
    icon: 'heart-pulse',
    description: 'AI solutions for patient care, medical research, and healthcare administration',
    subcategories: [
      {
        id: 'medical-imaging',
        name: 'Medical Imaging',
        description: 'AI-powered diagnostic tools and medical imaging analysis'
      },
      {
        id: 'patient-care',
        name: 'Patient Care',
        description: 'Virtual assistants and monitoring systems for patient management'
      },
      {
        id: 'health-analytics',
        name: 'Health Analytics',
        description: 'Data analysis and predictive modeling for healthcare insights'
      }
    ]
  },
  {
    id: 'marketing',
    name: 'Marketing & Sales',
    icon: 'megaphone',
    description: 'AI tools for content creation, social media, and campaign management',
    subcategories: [
      {
        id: 'content-creation',
        name: 'Content Creation',
        description: 'Generate blog posts, social media content, and marketing copy'
      },
      {
        id: 'social-media',
        name: 'Social Media Management',
        description: 'Schedule posts, analyze engagement, and optimize campaigns'
      },
      {
        id: 'seo',
        name: 'SEO Tools',
        description: 'Optimize content for search engines and improve rankings'
      },
      {
        id: 'email-marketing',
        name: 'Email Marketing',
        description: 'Create, optimize, and automate email marketing campaigns'
      }
    ]
  },
  {
    id: 'productivity',
    name: 'Productivity & Work',
    icon: 'clock',
    description: 'AI tools for task management, automation, and workflow optimization',
    subcategories: [
      {
        id: 'task-management',
        name: 'Task Management',
        description: 'Smart to-do lists and project management solutions'
      },
      {
        id: 'automation',
        name: 'Automation',
        description: 'Workflow automation and process optimization tools'
      },
      {
        id: 'communication',
        name: 'Communication',
        description: 'Email management and meeting assistant tools'
      }
    ]
  }
];